import { Link } from "react-router-dom";
import { FooterLogo, ShortBreakLine } from "../asset/img";
import { FamilySiteUpArrow, FamilySiteDownArrow, Instagram, NaverBlog } from "../asset/img";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../locales/i18n";

const SNS_INFOS = [
  {
    img: Instagram,
    url: "https://instagram.com/fourchains_insta?igshid=MmVlMjlkMTBhMg==",
  },
  { img: NaverBlog, url: "https://blog.naver.com/four-chains" }
];

const SITEMAP_LIST = [
  { title: "About", page: ["Home", "Vision", "History", "Management"], sectionTitle: "page" },
  { title: "Service", page: ["Solution", "Product"], sectionTitle: "service" },
  { title: "Team Culture", page: ["Culture", "Partner", "Team", "Colleague"], sectionTitle: "culture" },
  {
    title: "Community",
    page: ["NewsRoom"],
    sectionTitle: "community"
  },
];

const SITEMAP_LIST_LAST = [
  { page: "PartnerCompany", sectionTitle: "page", pageNum: 5 }
]

const FAMILYSITE_LIST = [
  { name: "FCTS", url: "https://fc-ts.com" },
  { name: "PROBE", url: "https://probe.kr/about" },
  { name: "MODULUS", url: "https://fcts-mod.com" },
  { name: "Crypto Blockchain", url: "https://cryptoblockchain.im/" },
  { name: "BI-Mining", url: "https://bi-mining.org" },
  { name: "EHT", url: "https://eht.im/" },
  { name: "PixeLock", url: "https://pixelock.im/" },
  { name: "StrongBox", url: "https://strongbox.im/" },
  { name: "ECCELIS", url: "https://eccelis.im/" },
];

const Footer = () => {
  const { t } = useTranslation();

  // 현재 언어 확인
  const isEN = i18n.language === 'en';


  const COMPANY_MAIN_INFOS = [
    {
      title: t(`Footer.CompanyMainInfo.ceotitle`),
      content: t(`Footer.CompanyMainInfo.ceocontent`),
    },
    {
      title: t(`Footer.CompanyMainInfo.companytitle`),
      content: t(`Footer.CompanyMainInfo.companycontent`),
    },
    {
      title: t(`Footer.CompanyMainInfo.researchtitle`),
      content: t(`Footer.CompanyMainInfo.reserchcontent`),
    },
  ];

  const COMPANY_INFOS = [
    {
      title: t(`Footer.CompanyInfo.teltitle`),
      content: `031-995-6409`,
    },
    {
      title: t(`Footer.CompanyInfo.emailtitle`),
      content: `info@four-chains.com`,
    },
    {
      title: t(`Footer.CompanyInfo.businesstitle`),
      content: "457-81-02412",
    },
  ];

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(false);

  const handleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const loginUser = localStorage.getItem("userName");
    if (loginUser) setIsLogin(true)
    else setIsLogin(false)
  }, [])

  const scrollTop = () => {
    window.scrollTo(0, 0);
  };

  const handleMenuClick = (section: string) => {
    scrollTop();
  };

  return (
    <div className="Footer">
      <section className="MainSection">
        <div className="LeftSection">
          <div className="CompanyName">{t(`Footer.companyname`)}</div>
          <a href="#">
            <img src={FooterLogo} alt="Fourchains footer logo" />
          </a>
          <div className="MiddleWrapper">
            <div className="CompanyInfoWrapper"
              style={{ whiteSpace: isEN ? 'pre-line' : undefined }}>
              {COMPANY_MAIN_INFOS.map((info) => {
                return (
                  <div key={info.title}>
                    {info.title} : {info.content}
                  </div>
                );
              })}
              {COMPANY_INFOS.map((info) => {
                return (
                  <span key={info.title} className="CompanyInfo">
                    <span>
                      {info.title} : {info.content}
                    </span>
                    {info.title !== "사업자 등록번호" && <span> | </span>}
                  </span>
                );
              })}
              {COMPANY_INFOS.map((info) => (
                <div className="CompanyInfoMobile" key={info.title}>
                  {info.title} : {info.content}
                </div>
              ))}
            </div>
          </div>
          <div className="CopyrightInfo">
            <div className="Crop">
              <span className="Underline">{t(`Footer.Etc.service`)}</span>
              <img
                src={ShortBreakLine}
                className="ShortBreakLine"
                alt="short break line"
              />
              <span className="Underline">{t(`Footer.Etc.privacy`)}</span>
              <img
                src={ShortBreakLine}
                className="ShortBreakLine"
                alt="short break line"
              />
              <Link to={"/Contact"} onClick={() => { handleMenuClick("") }}>
                <span className="Underline">{t(`Footer.Etc.IRandPR`)}</span>
              </Link>
            </div>
            <div className="Copyright">
              {t(`Footer.Etc.copyright`)}
            </div>
          </div>
          <div className="SnsWrapper">
            {SNS_INFOS.map((sns) => (
              <a target="_blank" key={sns.img} href={sns.url}>
                <img src={sns.img} />
              </a>
            ))}
          </div>
        </div>
        <div className="SiteInfo">
          <div className="TopSiteInfo">
            <div className="SiteMapFamilySiteWrapper">
              <div className="SiteMapTitle">{t(`Footer.Etc.sitemap`)}</div>
            </div>

            <div className="SiteMapListWrapper">
              {SITEMAP_LIST.map((menu) => (
                <div key={menu.sectionTitle}>
                  <Link to={menu.sectionTitle === "page" ? `/#${menu.sectionTitle}1` : `/${menu.sectionTitle}#${menu.sectionTitle}1`}>
                    <span>{menu.title}</span>
                  </Link>
                  {menu.page.map((page, idx) => (
                    <Link key={idx} to={menu.sectionTitle === "page" ? `/#${menu.sectionTitle}${idx + 1}` : `/${menu.sectionTitle}#${menu.sectionTitle}${idx + 1}`}>
                      <div className="SectionPageName">{page}</div>
                    </Link>
                  ))}
                </div>
              ))}
              <div className="LastSiteMapListWrapper">
                {SITEMAP_LIST_LAST.map((menu) => (
                  <Link key={menu.page} to={menu.sectionTitle === "page" ? `/#${menu.sectionTitle}${menu.pageNum}` : `/${menu.sectionTitle}#${menu.sectionTitle}${menu.pageNum}`}>
                    <div>{menu.page}</div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="BottomSiteInfo">
            <div className="FamilySiteBtn">
              <span onClick={handleDropdown}>
                {t(`Footer.Etc.familysite`)}
                <img src={isDropdownOpen ? FamilySiteDownArrow : FamilySiteUpArrow} alt="dropdown arrow button" />
              </span>
              {isDropdownOpen && (
                <div className="Dropdown">
                  <ul>
                    {FAMILYSITE_LIST.map((site) => {
                      return (
                        <a href={site.url} key={site.name} target="_blank">
                          <li className="FamilySiteName">{site.name}</li>
                        </a>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
            <div className="FamilySiteBtnDownWrapper">
              <div className="FamilySiteBtnDown">
                <span onClick={handleDropdown}>
                  패밀리 사이트
                  <img src={isDropdownOpen ? FamilySiteUpArrow : FamilySiteDownArrow} alt="dropdown arrow button" />
                </span>
                {isDropdownOpen && (
                  <div className="Dropdown">
                    <ul>
                      {FAMILYSITE_LIST.map((site) => {
                        return (
                          <a href={site.url} key={site.name} target="_blank">
                            <li className="FamilySiteName">{site.name}</li>
                          </a>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="ManagerWrapper">
              <Link to={isLogin ? "/FourchainsManagerFirstPage" : "/FourchainsManagerLoginPage"}>
                <span className="Underline">{t(`Footer.Etc.managerwrapper`)}</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
